export const DEFAULT_PAGE = 1;

export default function coerceSearchPage(rawPage) {
  const page = Number(rawPage);
  return Number.isInteger(page) && page > 0 ? page : DEFAULT_PAGE;
}
